import { API, Logger, graphqlOperation } from 'aws-amplify';

import { manageResource } from '../../../graphql/mutations';

import { fmtErrorAsString } from '../../utils/formatters';

const logger = new Logger('useResourceManager');

export function createResource(resourceType, resourceProps={}) {
  const variables = {
    command: 'Create',
    args: JSON.stringify({
      ResourceType: resourceType,
      ...resourceProps
    })
  };
  return _manageResource(variables);
}

export function deleteResource(resourceId) {
  const variables = {
    command: 'Delete',
    args: JSON.stringify({
      ResourceId: resourceId
    })
  };
  return _manageResource(variables);
}

export function startResource(resourceId) {
  const variables = {
    command: 'Start',
    args: JSON.stringify({
      ResourceId: resourceId
    })
  };
  return _manageResource(variables);
}

export function stopResource(resourceId) {
  const variables = {
    command: 'Stop',
    args: JSON.stringify({
      ResourceId: resourceId
    })
  };
  return _manageResource(variables);
}

export function updateResource(resourceId, resourceProps={}) {
  const variables = {
    command: 'Update',
    args: JSON.stringify({
      ResourceId: resourceId,
      ...resourceProps
    })
  };
  return _manageResource(variables);
}

async function _manageResource(variables) {

  var res;
  try {
    logger.info('manageResource MUTATION: ',manageResource);
    logger.info('manageResource VARIABLES: ',variables);
    res=await API.graphql(graphqlOperation(manageResource, variables));
    logger.info('resource manager success: ',res);
    if (res.data?.manageResource) {
      return {
        succeeded: true,
        data: JSON.parse(res.data.manageResource),
        error: null,
      };
    } else {
      throw 'server did not return a valid response';
    }    
  } catch (err) {
    logger.error(`resource manager failure: ${JSON.stringify(err)}\n...on MUTATION:${manageResource}...with VARIABLES:\n${JSON.stringify(variables)}\n...and RESPONSE:\n${JSON.stringify(res)}`);
    return {
      succeeded: false,
      data: null,
      error: fmtErrorAsString(err),
    };
  }
}
